//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Moment from "moment";
var BASE_URL = "/prototype/properties/reports";
import { createExport } from "@/mixins/createExport";

export default {
  mixins: [createExport],
  data: function data() {
    var $el = this;
    return {
      loading: true,
      headers: [],
      items: [],
      totals: [],
      exportExcel: false,
      exportPDF: false
    };
  },

  props: ["reportId", "reportType", "reportTable"],
  created: function created() {
    var _this = this;

    Event.$on("report", function () {
      _this.$children[0].showModal = true;
      _this.load();
    });
  },
  beforeDestroy: function beforeDestroy() {
    Event.$off("report");
  },
  mounted: function mounted() {
    var $el = this;
    this.getReport();
  },

  methods: {
    getReport: function getReport() {
      var _this2 = this;

      this.loading = true;
      axios.post("/prototype/reporting/get-report", {
        type: this.reportId,
        table: this.reportTable
      }).then(function (response) {
        if (response.data) {
          _this2.headers = response.data.header;
          _this2.items = response.data.group_result;
          _this2.loading = false;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    exportToExcel: function exportToExcel() {
      Event.$emit("export-report", {
        type: this.reportId,
        table: this.reportTable
      });
    },
    exportToPdf: function exportToPdf() {
      var data = {
        type: this.reportId,
        table: this.reportTable
      };

      this.createExport(data, "/prototype/reporting/export-pdf", "unit-availability", ".pdf");
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/reports/UnitAvailabilityReport.vue
// module id = T0nn
// module chunks = 0 1